import React, {useContext} from 'react';
import {UserContext} from 'context/UserContext';
import {useHistory, useParams} from 'react-router-dom';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {calculateCompleteProfile, isSkipQuestionnairePossible} from 'constants/UserProfileComplete';
import Routes from 'constants/Routes';
import Button, {ButtonStyles} from 'components/common/Form/Button';
import styles from './FacebookAuth.module.scss';
import {FacebookIcon} from 'components/common/icons';
import {useTranslation} from 'react-i18next';
import config from 'config';

const FacebookAuth = ({error, success, isLogin}) => {
    const {authApi} = useContext(UserContext);
    const params = useParams();
    const history = useHistory();
    const {t} = useTranslation();
    const {role} = params;
    const appId = config.facebookAppId;

    const facebookLabel = (
        <span className={styles.buttonLabel}>
            <FacebookIcon />
            <span>{t('auth:text.facebook')}</span>
        </span>
    );

    const responseFacebook = res => {
        const accessToken = res.accessToken;
        if (!accessToken) {
            console.log(res);
            return;
        }
        authApi({accessToken, role, type: 'facebook', isLogin}, (err, res) => {
            if (err) {
                console.log(err);
                return error(accessToken);
            }
            if (!success) {
                const {user} = res;
                const complete = calculateCompleteProfile(user);
                if (isSkipQuestionnairePossible(user.role, complete)) {
                    history.push(Routes.browseInterviews.path);
                } else {
                    history.push(Routes.welcome.path);
                }
            } else success();
        });
    };

    return (
        <FacebookLogin
            appId={appId}
            callback={responseFacebook}
            render={renderProps => (
                <Button
                    btnStyle={ButtonStyles.blue}
                    className={styles.button}
                    text={facebookLabel}
                    onClick={renderProps.onClick}
                />
            )}
        />
    );
};

export default FacebookAuth;
